var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOMacron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.452,
    height: 20,
    viewBox: "0 0 16.452 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Macron",
    transform: "translate(8.226 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Macron-2",
    "data-name": "Macron",
    transform: "translate(-8.226 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M14.4,24.248a7.761,7.761,0,0,0-6.167-2.694A7.792,7.792,0,0,0,2.05,24.248,9.45,9.45,0,0,0,0,30.357a9.452,9.452,0,0,0,2.05,6.109,7.793,7.793,0,0,0,6.187,2.693A7.76,7.76,0,0,0,14.4,36.466a9.464,9.464,0,0,0,2.047-6.109A9.463,9.463,0,0,0,14.4,24.248M8.238,37C3.951,37,2.43,33.421,2.43,30.357s1.521-6.642,5.808-6.642c2.668,0,5.784,1.74,5.784,6.642,0,3.064-1.515,6.643-5.784,6.643",
    transform: "translate(0 -19.159)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1617",
    "data-name": "Rectangle 1617",
    width: 12.23,
    height: 1.597,
    transform: "translate(2.111)",
    fill: "#004987"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOMacron);
export default __webpack_public_path__ + "static/media/OMacron.c3996177a42d16bc6a26268db45c8d70.svg";
export { ForwardRef as ReactComponent };